import moment from 'moment';
import { PaginatedResource } from '../../typings/Paginated';
import { BaseService, GenericPaginatedParameters, Unauthorized, UnexpectedError } from './base-service';

export enum Action {
    CREATE_AUDIT_LOGS_REPORT = 'CREATE_AUDIT_LOGS_REPORT',
    CREATE_USER = 'CREATE_USER',
    DELETE_USER = 'DELETE_USER',
    EDIT_CAMERA = 'EDIT_CAMERA',
    GENERATE_CAMERA_DOWNLOAD = 'GENERATE_CAMERA_DOWNLOAD',
    DOWNLOAD_CAMERA = 'DOWNLOAD_CAMERA',
    DISABLE_CAMERA = 'DISABLE_CAMERA',
    ENABLE_CAMERA = 'ENABLE_CAMERA',
    LOGIN = 'LOGIN',
    LOGOUT = 'LOGOUT',
    CREATE_CAMERA = 'CREATE_CAMERA',
    GET_CAMERA = 'GET_CAMERA',
    GET_CAMERA_TIMELINE = 'GET_CAMERA_TIMELINE',
    GET_CAMERA_LIVE = 'GET_CAMERA_LIVE',
    GET_CAMERAS_REPORT = 'GET_CAMERAS_REPORT',
    GET_CAMERAS_ONLINE_TIME_REPORT = 'GET_CAMERAS_ONLINE_TIME_REPORT',
    DELETE_CAMERA = 'DELETE_CAMERA',
    CAMERA_PTZ_MOVE = 'CAMERA_PTZ_MOVE',
    SET_CAMERA_PTZ_PRESET = 'SET_CAMERA_PTZ_PRESET',
    GO_TO_CAMERA_PTZ_PRESET = 'GO_TO_CAMERA_PTZ_PRESET',
    GET_EVENTS_BY_PICTURE = 'GET_EVENTS_BY_PICTURE',
    GET_PEOPLE_BY_PICTURE = 'GET_PEOPLE_BY_PICTURE',
    ADDED_FACE_TO_PERSON = 'ADDED_FACE_TO_PERSON',
    DELETED_FACE_FROM_PERSON = 'DELETED_FACE_FROM_PERSON',
    EDIT_USER = 'EDIT_USER',
    CREATE_GROUP = 'CREATE_GROUP',
    EDIT_GROUP = 'EDIT_GROUP',
    DELETE_GROUP = 'DELETE_GROUP',
    CREATE_SKILL = 'CREATE_SKILL',
    EDIT_SKILL = 'EDIT_SKILL',
    DELETE_SKILL = 'DELETE_SKILL',
    CREATE_ASSIGNMENT = 'CREATE_ASSIGNMENT',
    EDIT_ASSIGNMENT = 'EDIT_ASSIGNMENT',
    DELETE_ASSIGNMENT = 'DELETE_ASSIGNMENT',
    CREATE_PLATE = 'CREATE_PLATE',
    EDIT_PLATE = 'EDIT_PLATE',
    EDIT_DETECTION = 'EDIT_DETECTION',
    DELETE_PLATE = 'DELETE_PLATE',
    CREATE_TAG = 'CREATE_TAG',
    EDIT_TAG = 'EDIT_TAG',
    DELETE_TAG = 'DELETE_TAG',
    CREATE_MOSAIC = 'CREATE_MOSAIC',
    EDIT_MOSAIC = 'EDIT_MOSAIC',
    DELETE_MOSAIC = 'DELETE_MOSAIC',
    WATCH_MOSAIC = 'WATCH_MOSAIC',
    CREATE_PERMISSION = 'CREATE_PERMISSION',
    EDIT_PERMISSION = 'EDIT_PERMISSION',
    DELETE_PERMISSION = 'DELETE_PERMISSION',
    CREATE_ACTING_BODY = 'CREATE_ACTING_BODY',
    EDIT_ACTING_BODY = 'EDIT_ACTING_BODY',
    DELETE_ACTING_BODY = 'DELETE_ACTING_BODY',
    CREATE_OBJECT_CATEGORY = 'CREATE_OBJECT_CATEGORY',
    EDIT_OBJECT_CATEGORY = 'EDIT_OBJECT_CATEGORY',
    DELETE_OBJECT_CATEGORY = 'DELETE_OBJECT_CATEGORY',
    DELETE_OBJECT_SUB_CATEGORY = 'DELETE_OBJECT_SUB_CATEGORY',
    CREATE_INSTALLATION_COMPANY = 'CREATE_INSTALLATION_COMPANY',
    EDIT_INSTALLATION_COMPANY = 'EDIT_INSTALLATION_COMPANY',
    DELETE_INSTALLATION_COMPANY = 'DELETE_INSTALLATION_COMPANY',
    EDIT_TERMS_OF_USE = 'EDIT_TERMS_OF_USE',
    EDIT_FREQUENTLY_ASKED_QUESTIONS = 'EDIT_FREQUENTLY_ASKED_QUESTIONS',
    EDIT_EMAIL_RECIPIENTS = 'EDIT_EMAIL_RECIPIENTS',
    EDIT_LOGIN_ATTEMPT_LIMITS = 'EDIT_LOGIN_ATTEMPT_LIMITS',
    EDIT_SESSION_CONFIG = 'EDIT_SESSION_CONFIG',
    CREATE_DISPATCH_REPORT = 'CREATE_DISPATCH_REPORT',
    CREATE_DISPATCH_EQUIPMENT = 'CREATE_DISPATCH_EQUIPMENT',
    EDIT_DISPATCH_EQUIPMENT = 'EDIT_DISPATCH_EQUIPMENT',
    DELETE_DISPATCH_EQUIPMENT = 'DELETE_DISPATCH_EQUIPMENT',
    CREATE_DISPATCH_OCCURRENCE_TYPE = 'CREATE_DISPATCH_OCCURRENCE_TYPE',
    EDIT_DISPATCH_OCCURRENCE_TYPE = 'EDIT_DISPATCH_OCCURRENCE_TYPE',
    DELETE_DISPATCH_OCCURRENCE_TYPE = 'DELETE_DISPATCH_OCCURRENCE_TYPE',
    EDIT_DISPATCH_VEHICLE = 'EDIT_DISPATCH_VEHICLE',
    CREATE_INTERNET_COMPANY = 'CREATE_INTERNET_COMPANY',
    EDIT_INTERNET_COMPANY = 'EDIT_INTERNET_COMPANY',
    DELETE_INTERNET_COMPANY = 'DELETE_INTERNET_COMPANY',
    CREATE_ROLE = 'CREATE_ROLE',
    UPDATE_ROLE = 'UPDATE_ROLE',
    DELETE_ROLE = 'DELETE_ROLE',
    CREATE_ACTING_BODY_COMMAND = 'CREATE_ACTING_BODY_COMMAND',
    UPDATE_ACTING_BODY_COMMAND = 'UPDATE_ACTING_BODY_COMMAND',
    DELETE_ACTING_BODY_COMMAND = 'DELETE_ACTING_BODY_COMMAND',
    CREATE_ACTING_BODY_UNIT = 'CREATE_ACTING_BODY_UNIT',
    UPDATE_ACTING_BODY_UNIT = 'UPDATE_ACTING_BODY_UNIT',
    DELETE_ACTING_BODY_UNIT = 'DELETE_ACTING_BODY_UNIT',
    CREATE_POINT_OF_INTEREST = 'CREATE_POINT_OF_INTEREST',
    EDIT_POINT_OF_INTEREST = 'EDIT_POINT_OF_INTEREST',
    DELETE_POINT_OF_INTEREST = 'DELETE_POINT_OF_INTEREST',
    CREATE_UNIT = 'CREATE_UNIT',
    EDIT_UNIT = 'EDIT_UNIT',
    DELETE_UNIT = 'DELETE_UNIT',
    ACCEPTED_TERMS_OF_USE = 'ACCEPTED_TERMS_OF_USE',
    CHANGE_AGENT_ASSIGNMENT_ON_UNIT = 'CHANGE_AGENT_ASSIGNMENT_ON_UNIT',
    CHANGE_AGENT_UNIT = 'CHANGE_AGENT_UNIT',
    PAUSED_UNIT = 'PAUSED_UNIT',
    UNPAUSED_UNIT = 'UNPAUSED_UNIT',
    APP_AGENT_PAUSED_UNIT = 'APP_AGENT_PAUSED_UNIT',
    APP_AGENT_UNPAUSED_UNIT = 'APP_AGENT_UNPAUSED_UNIT',
    ACTIVATE_AGENT_UNIT = 'ACTIVATE_AGENT_UNIT',
    AGENT_EDIT_ACTIVE_UNIT = 'AGENT_EDIT_ACTIVE_UNIT',
    ACTIVATED_UNIT = 'ACTIVATED_UNIT',
    DEACTIVATED_UNIT = 'DEACTIVATED_UNIT',
    DEACTIVATE_AGENT_UNIT = 'DEACTIVATE_AGENT_UNIT',
    DEACTIVATED_AGENT_UNIT = 'DEACTIVATED_AGENT_UNIT',
    CHANGED_PTZ_PRIORITIES = 'CHANGED_PTZ_PRIORITIES',
    CREATE_FACIAL_PERSON = 'CREATE_FACIAL_PERSON',
    UPDATE_FACIAL_PERSON = 'UPDATE_FACIAL_PERSON',
    DELETE_FACIAL_PERSON = 'DELETE_FACIAL_PERSON',
    CREATE_FACIAL_MARKER = 'CREATE_FACIAL_MARKER',
    UPDATE_FACIAL_MARKER = 'UPDATE_FACIAL_MARKER',
    DELETE_FACIAL_MARKER = 'DELETE_FACIAL_MARKER',
    VEHICLE_INACTIVATED = 'VEHICLE_INACTIVATED',
    VEHICLE_ACTIVATED = 'VEHICLE_ACTIVATED',
    CREATE_DISPATCH_VEHICLE_RELATION = 'CREATE_DISPATCH_VEHICLE_RELATION',
    EDIT_DISPATCH_VEHICLE_RELATION = 'EDIT_DISPATCH_VEHICLE_RELATION',
    DELETE_DISPATCH_VEHICLE_RELATION = 'DELETE_DISPATCH_VEHICLE_RELATION',
    CREATE_DISPATCH_PERSON_RELATION = 'CREATE_DISPATCH_PERSON_RELATION',
    EDIT_DISPATCH_PERSON_RELATION = 'EDIT_DISPATCH_PERSON_RELATION',
    DELETE_DISPATCH_PERSON_RELATION = 'DELETE_DISPATCH_PERSON_RELATION',
    UPDATE_USER_FACE_PICTURE = 'UPDATE_USER_FACE_PICTURE',
    CREATE_ALARM_CENTER = 'CREATE_ALARM_CENTER',
    EDIT_ALARM_CENTER = 'EDIT_ALARM_CENTER',
    DELETE_ALARM_CENTER = 'DELETE_ALARM_CENTER',
    GENERATE_CAMERA_VIDEO_ANALYSIS = 'GENERATE_CAMERA_VIDEO_ANALYSIS',
    CREATE_TURNSTILE_GROUP = 'CREATE_TURNSTILE_GROUP',
    EDIT_TURNSTILE_GROUP = 'EDIT_TURNSTILE_GROUP',
    DELETE_TURNSTILE_GROUP = 'DELETE_TURNSTILE_GROUP',
    CREATE_LPR_DETECTIONS_REPORT = 'CREATE_LPR_DETECTIONS_REPORT',
    EDIT_TEAM_NAME = 'EDIT_TEAM_NAME',
    CREATE_TEAM_NAME = 'CREATE_TEAM_NAME',
    DELETE_TEAM_NAME = 'DELETE_TEAM_NAME',
    CREATE_FINISH_CATEGORY = 'CREATE_FINISH_CATEGORY',
    EDIT_FINISH_CATEGORY = 'EDIT_FINISH_CATEGORY',
    DELETE_FINISH_CATEGORY = 'DELETE_FINISH_CATEGORY',
    DELETE_FINISH_SUB_CATEGORY = 'DELETE_FINISH_SUB_CATEGORY',
    UNIT_DISPATCHED = 'UNIT_DISPATCHED',
    CREATE_OCCURRENCE = 'CREATE_OCCURRENCE',
    CREATE_GUARDIAN_WOMAN = 'CREATE_GUARDIAN_WOMAN',
    EDIT_GUARDIAN_WOMAN = 'EDIT_GUARDIAN_WOMAN',
    DELETE_GUARDIAN_WOMAN = 'DELETE_GUARDIAN_WOMAN',
    SEARCH_ON_CORTEX = 'SEARCH_ON_CORTEX',
    GET_CAMERA_PASSWORD = 'GET_CAMERA_PASSWORD',
    ADDED_OCCURRENCE_REPORT = 'ADDED_OCCURRENCE_REPORT',
    ADDED_OCCURRENCE_FINAL_REPORT = 'ADDED_OCCURRENCE_FINAL_REPORT',
    ADDED_OCCURRENCE_HANDCUFF_EXPLANATION = 'ADDED_OCCURRENCE_HANDCUFF_EXPLANATION',
    ADDED_OCCURRENCE_ATTACHMENT = 'ADDED_OCCURRENCE_ATTACHMENT',
    GET_CAMERAS_DASHBOARD = 'GET_CAMERAS_DASHBOARD',
    GET_OCCURRENCES_DASHBOARD = 'GET_OCCURRENCES_DASHBOARD',
    GET_AGENTS_DASHBOARD = 'GET_AGENTS_DASHBOARD',
    GET_VEHICLES_DASHBOARD = 'GET_VEHICLES_DASHBOARD',
    GET_LOGS = 'GET_LOGS',
    SILENCED_CAMERA_EVENTS = 'SILENCED_CAMERA_EVENTS',
    REJECT_THIRD_PARTY_CAMERA = 'REJECT_THIRD_PARTY_CAMERA',
    RE_ENABLE_THIRD_PARTY_CAMERA = 'RE_ENABLE_THIRD_PARTY_CAMERA',
    CREATE_DISPATCH_UNIT_PROGRAM = 'CREATE_DISPATCH_UNIT_PROGRAM',
    EDIT_DISPATCH_UNIT_PROGRAM = 'EDIT_DISPATCH_UNIT_PROGRAM',
    DELETE_DISPATCH_UNIT_PROGRAM = 'DELETE_DISPATCH_UNIT_PROGRAM',
    CREATE_DISPATCH_POLICE_STATION = 'CREATE_DISPATCH_POLICE_STATION',
    EDIT_DISPATCH_POLICE_STATION = 'EDIT_DISPATCH_POLICE_STATION',
    DELETE_DISPATCH_POLICE_STATION = 'DELETE_DISPATCH_POLICE_STATION',
    CREATE_DISPATCH_PROVIDENCE = 'CREATE_DISPATCH_PROVIDENCE',
    EDIT_DISPATCH_PROVIDENCE = 'EDIT_DISPATCH_PROVIDENCE',
    DELETE_DISPATCH_PROVIDENCE = 'DELETE_DISPATCH_PROVIDENCE',
    CREATE_DISPATCH_UNIT_PAUSE_REASON = 'CREATE_DISPATCH_UNIT_PAUSE_REASON',
    EDIT_DISPATCH_UNIT_PAUSE_REASON = 'EDIT_DISPATCH_UNIT_PAUSE_REASON',
    DELETE_DISPATCH_UNIT_PAUSE_REASON = 'DELETE_DISPATCH_UNIT_PAUSE_REASON',
    CREATE_DISPATCH_UNIT_FINISH_EARLY_REASON = 'CREATE_DISPATCH_UNIT_FINISH_EARLY_REASON',
    EDIT_DISPATCH_UNIT_FINISH_EARLY_REASON = 'EDIT_DISPATCH_UNIT_FINISH_EARLY_REASON',
    DELETE_DISPATCH_UNIT_FINISH_EARLY_REASON = 'DELETE_DISPATCH_UNIT_FINISH_EARLY_REASON',
    DOWNLOAD_SIGNABLE_REPORT = 'DOWNLOAD_SIGNABLE_REPORT',
    CREATE_DISPATCH_CITY_PROPERTY = 'CREATE_DISPATCH_CITY_PROPERTY',
    EDIT_DISPATCH_CITY_PROPERTY = 'EDIT_DISPATCH_CITY_PROPERTY',
    DELETE_DISPATCH_CITY_PROPERTY = 'DELETE_DISPATCH_CITY_PROPERTY',
    CREATE_ALERT_GROUP = 'CREATE_ALERT_GROUP',
    EDIT_ALERT_GROUP = 'EDIT_ALERT_GROUP',
    DELETE_ALERT_GROUP = 'DELETE_ALERT_GROUP',
    RECEIVED_SUPPORT = 'RECEIVED_SUPPORT',
    CREATE_ALLOWED_IP = 'CREATE_ALLOWED_IP',
    EDIT_ALLOWED_IP = 'EDIT_ALLOWED_IP',
    DELETE_ALLOWED_IP = 'DELETE_ALLOWED_IP',
    AGENT_DECLARE_NO_POLICE_REPORT = 'AGENT_DECLARE_NO_POLICE_REPORT',
    EDIT_CONFIGURATION_EVENT_INTEGRATION = 'EDIT_CONFIGURATION_EVENT_INTEGRATION',
    CREATE_DISPATCH_HANDCUFF_REASON = 'CREATE_DISPATCH_HANDCUFF_REASON',
    EDIT_DISPATCH_HANDCUFF_REASON = 'EDIT_DISPATCH_HANDCUFF_REASON',
    DELETE_DISPATCH_HANDCUFF_REASON = 'DELETE_DISPATCH_HANDCUFF_REASON',
    CREATE_DISPATCH_UNIT_DISPLACED_REASON = 'CREATE_DISPATCH_UNIT_DISPLACED_REASON',
    EDIT_DISPATCH_UNIT_DISPLACED_REASON = 'EDIT_DISPATCH_UNIT_DISPLACED_REASON',
    CREATE_ARMORY_SHIFT = 'CREATE_ARMORY_SHIFT',
    EDIT_ARMORY_SHIFT = 'EDIT_ARMORY_SHIFT',
    DELETE_ARMORY_SHIFT = 'DELETE_ARMORY_SHIFT',
    FINISH_ARMORY_SHIFT = 'FINISH_ARMORY_SHIFT',
    START_ARMORY_SHIFT = 'START_ARMORY_SHIFT',
    ARMORY_SHIFT_SAVE_REPORT = 'ARMORY_SHIFT_SAVE_REPORT',
    SIGN_HANDOVER_REPORT_ARMORY_SHIFT = 'SIGN_HANDOVER_REPORT_ARMORY_SHIFT',
    REJECTED_HANDOVER_REPORT_ARMORY_SHIFT = 'REJECTED_HANDOVER_REPORT_ARMORY_SHIFT',
    REPLACED_IN_CHARGE_ARMOURER = 'REPLACED_IN_CHARGE_ARMOURER',
    CREATE_VACANCY_LEVEL = 'CREATE_VACANCY_LEVEL',
    EDIT_VACANCY_LEVEL = 'EDIT_VACANCY_LEVEL',
    DELETE_VACANCY_LEVEL = 'DELETE_VACANCY_LEVEL',
    CREATE_WORKPLACE = 'CREATE_WORKPLACE',
    EDIT_WORKPLACE = 'EDIT_WORKPLACE',
    DELETE_WORKPLACE = 'DELETE_WORKPLACE',
    CREATE_VACANCY_TAG = 'CREATE_VACANCY_TAG',
    EDIT_VACANCY_TAG = 'EDIT_VACANCY_TAG',
    DELETE_VACANCY_TAG = 'DELETE_VACANCY_TAG',
    CREATE_VACANCY_CANCELLATION_REASON = 'CREATE_VACANCY_CANCELLATION_REASON',
    EDIT_VACANCY_CANCELLATION_REASON = 'EDIT_VACANCY_CANCELLATION_REASON',
    DELETE_VACANCY_CANCELLATION_REASON = 'DELETE_VACANCY_CANCELLATION_REASON',
    CREATE_VACANCY = 'CREATE_VACANCY',
    EDIT_VACANCY = 'EDIT_VACANCY',
    DELETE_VACANCY = 'DELETE_VACANCY',
    APP_AGENT_VACANCY_APPLICATION = 'APP_AGENT_VACANCY_APPLICATION',
    APP_AGENT_VACANCY_CANCELLATION = 'APP_AGENT_VACANCY_CANCELLATION',
    WEB_PANEL_VACANCY_CANCELLATION = 'WEB_PANEL_VACANCY_CANCELLATION',
    VACANCY_PRESENCE_REGISTRATION = 'VACANCY_PRESENCE_REGISTRATION',
    CREATE_DEAC_REPORT = 'CREATE_DEAC_REPORT',
    DISABLE_APP_AGENT_SERVICE = 'DISABLE_APP_AGENT_SERVICE',
    ENABLE_APP_AGENT_SERVICE = 'ENABLE_APP_AGENT_SERVICE',
    CAMERA_FACTORY_RESET = 'CAMERA_FACTORY_RESET',
    CREATE_WORK_SCHEDULE = 'CREATE_WORK_SCHEDULE',
    EDIT_WORK_SCHEDULE = 'EDIT_WORK_SCHEDULE',
    DELETE_WORK_SCHEDULE = 'DELETE_WORK_SCHEDULE',
    CREATE_HOLIDAY = 'CREATE_HOLIDAY',
    EDIT_HOLIDAY = 'EDIT_HOLIDAY',
    DELETE_HOLIDAY = 'DELETE_HOLIDAY',
    CREATE_VACANCY_TEMPLATE = 'CREATE_VACANCY_TEMPLATE',
    EDIT_VACANCY_TEMPLATE = 'EDIT_VACANCY_TEMPLATE',
    DELETE_VACANCY_TEMPLATE = 'DELETE_VACANCY_TEMPLATE',
    CREATE_IGNORED_PERSON = 'CREATE_IGNORED_PERSON',
    EDIT_IGNORED_PERSON = 'EDIT_IGNORED_PERSON',
    DELETE_IGNORED_PERSON = 'DELETE_IGNORED_PERSON',
    CREATE_PATROL_INDICATOR = 'CREATE_PATROL_INDICATOR',
    EDIT_PATROL_INDICATOR = 'EDIT_PATROL_INDICATOR',
    DELETE_PATROL_INDICATOR = 'DELETE_PATROL_INDICATOR',
    APP_AGENT_CREATE_ACTIVITY_AND_SERVICE = 'APP_AGENT_CREATE_ACTIVITY_AND_SERVICE',
    APP_AGENT_EDIT_ACTIVITY_AND_SERVICE = 'APP_AGENT_EDIT_ACTIVITY_AND_SERVICE',
    APP_AGENT_DELETE_ACTIVITY_AND_SERVICE = 'APP_AGENT_DELETE_ACTIVITY_AND_SERVICE',
    CREATE_PATROL_ACTIVITY = 'CREATE_PATROL_ACTIVITY',
    EDIT_PATROL_ACTIVITY = 'EDIT_PATROL_ACTIVITY',
    DELETE_PATROL_ACTIVITY = 'DELETE_PATROL_ACTIVITY',

    // Third Party Company Inscription
    THIRD_PARTY_COMPANY_CREATE_INSCRIPTION = 'THIRD_PARTY_COMPANY_CREATE_INSCRIPTION',
    THIRD_PARTY_COMPANY_UPDATE_INSCRIPTION = 'THIRD_PARTY_COMPANY_UPDATE_INSCRIPTION',
    THIRD_PARTY_COMPANY_DELETE_INSCRIPTION = 'THIRD_PARTY_COMPANY_DELETE_INSCRIPTION',

    // Citizen
    CREATE_CITIZEN = 'CREATE_CITIZEN',
    UPDATE_CITIZEN = 'UPDATE_CITIZEN',
    DELETE_CITIZEN = 'DELETE_CITIZEN',
    CREATE_CITIZEN_BLOCK_REASON = 'CREATE_CITIZEN_BLOCK_REASON',
    UPDATE_CITIZEN_BLOCK_REASON = 'UPDATE_CITIZEN_BLOCK_REASON',
    DELETE_CITIZEN_BLOCK_REASON = 'DELETE_CITIZEN_BLOCK_REASON',

    // OccurrenceHistoricAction
    FINISHED_OCCURRENCE = 'FINISHED_OCCURRENCE',
    OCCURRENCE_HANDLED = 'OCCURRENCE_HANDLED',
    OCCURRENCE_CREATED_INVOLVED_OBJECT = 'OCCURRENCE_CREATED_INVOLVED_OBJECT',
    OCCURRENCE_UPDATED_INVOLVED_OBJECT = 'OCCURRENCE_UPDATED_INVOLVED_OBJECT',
    OCCURRENCE_REMOVED_INVOLVED_OBJECT = 'OCCURRENCE_REMOVED_INVOLVED_OBJECT',
    OCCURRENCE_CREATED_INVOLVED_PERSON = 'OCCURRENCE_CREATED_INVOLVED_PERSON',
    OCCURRENCE_UPDATED_INVOLVED_PERSON = 'OCCURRENCE_UPDATED_INVOLVED_PERSON',
    OCCURRENCE_REMOVED_INVOLVED_PERSON = 'OCCURRENCE_REMOVED_INVOLVED_PERSON',
    OCCURRENCE_CREATED_INVOLVED_VEHICLE = 'OCCURRENCE_CREATED_INVOLVED_VEHICLE',
    OCCURRENCE_UPDATED_INVOLVED_VEHICLE = 'OCCURRENCE_UPDATED_INVOLVED_VEHICLE',
    OCCURRENCE_REMOVED_INVOLVED_VEHICLE = 'OCCURRENCE_REMOVED_INVOLVED_VEHICLE',
    UPDATED_OCCURRENCE_POSITION = 'UPDATED_OCCURRENCE_POSITION',
    OCCURRENCE_CREATED_HISTORIC_TITLE = 'OCCURRENCE_CREATED_HISTORIC_TITLE',
    OCCURRENCE_ASSUMED = 'OCCURRENCE_ASSUMED',
    OCCURRENCE_TRANSFER = 'OCCURRENCE_TRANSFER',
    OCCURRENCE_UPDATED_HISTORIC_TITLE = 'OCCURRENCE_UPDATED_HISTORIC_TITLE',
    UNIT_DISASSOCIATED_TO_OCCURRENCE_HISTORIC_TITLE = 'UNIT_DISASSOCIATED_TO_OCCURRENCE_HISTORIC_TITLE',
    UNIT_ASSOCIATED_TO_OCCURRENCE_HISTORIC_TITLE = 'UNIT_ASSOCIATED_TO_OCCURRENCE_HISTORIC_TITLE',
    UNIT_SET_STARTER_HISTORIC_TITLE = 'UNIT_SET_STARTER_HISTORIC_TITLE',
    UNIT_SET_DISPLACED_HISTORIC_TITLE = 'UNIT_SET_DISPLACED_HISTORIC_TITLE',
    UNIT_REMOVE_DISPLACED_HISTORIC_TITLE = 'UNIT_REMOVE_DISPLACED_HISTORIC_TITLE',
    REOPENED_OCCURRENCE = 'REOPENED_OCCURRENCE',
    SIGNED_AS_SUPERVISOR = 'SIGNED_AS_SUPERVISOR',
    SIGNED_AS_TEAM = 'SIGNED_AS_TEAM',
    BULK_FINISHED = 'BULK_FINISHED',
}

export interface Log {
    id: string;
    action: Action;
    /**
     * The log date. Its a UTC date represented as string.
     * You can use `new Date(Log.date)` to cast it as Date.
     */
    date: string;
    userId?: number;
    userName?: string;
    ip?: string;
    detail?: { [key: string]: string | number | boolean; };
}

export interface GetLogsParameters {
    page: number;
    limit: number;
    sort?: 'asc' | 'desc';
    userId?: number;
    dateGte?: number;
    dateLte?: number;
    queryString?: string;
    action?: string;
}

interface CreateReportParameters {
    name: string;
    startDate: string;
    endDate: string;
    userId?: number;
    action?: Action;
    isPdf?: boolean;
}

class AuditLogsService extends BaseService {
    async getLogs(params: GetLogsParameters): Promise<Log[]> {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/audit-logs${this.encodeQueryParams({
            ...params,
            dateGte: params.dateGte ? moment(params.dateGte).toISOString() : undefined,
            dateLte: params.dateLte ? moment(params.dateLte).toISOString() : undefined
        })}`, {
            method: 'GET',
            headers: this.getHeaders(token),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }

    async getAllUsers(): Promise<AuditLogsSimplifiedUserData[]> {
        const token = await this.getToken();
        const res = await fetch(`${this.centralEndpoint}/audit-logs/users`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }

    async createReport(params: CreateReportParameters) {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/audit-logs/report`, {
            method: 'POST',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
            body: JSON.stringify(params)
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status == 204) {
            return [];
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }
    }

    async getReports(params: GenericPaginatedParameters): Promise<PaginatedResource<LogsReport>> {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/audit-logs/reports/paginated${this.encodeQueryParams({
            ...params,
        })}`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }

    async getReport(id: number): Promise<{ resultUrl: string; }> {
        const token = await this.getToken();
        const res = await fetch(`${this.centralEndpoint}/audit-logs/report/${id}`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }
}

export const auditLogsService = new AuditLogsService();
